"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var withContext_1 = require("../../utils/hoc/withContext");
var PremiumBoxWithinContext_1 = require("./PremiumBoxWithinContext");
/**
 * The `PremiumBox` component is used to display the (insurance) costs for
 * different payment intervals (once, monthly, quarterly, yearly etc.).
 */
exports.PremiumBox = withContext_1.withErgoElementsContext('PremiumBox', PremiumBoxWithinContext_1.PremiumBoxWithinContext);
exports.default = exports.PremiumBox;
__export(require("./PremiumBoxWithinContext"));
//# sourceMappingURL=PremiumBox.js.map
